import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../variables";
import PropTypes from "prop-types";
import _ from "lodash";
import {
  patchTransferReservation,
  retrieveTransferReservation,
} from "../../../../../api/CRS/Transfers";
import { Price } from "../../../../../components/Price";
import { DateTime } from "luxon";
import GuestCard from "../../../../../components/cards/GuestInfo";
import useReservationDetails from "../../../../../hooks";
import EditGuestModal from "../../../CommonCRSModals/EditGuestModal";
import EmailsCard from "../../../../../components/cards/emails";
import Loader from "../../../../../components/Loader";
import EditCRSTagModal from "../../../CommonCRSModals/EditCRSTagModal";
import { toast } from "react-toastify";
import ReservationEventsModal from "../../../ReservationEventsModal";
import { DocumentsCRSCard } from "../../../CommonCRSModals/DocumentsCRS/List";
import ReservationsStatusTag from "../../../../../components/Tags/ReservationsStatusTag";
import TabStrip from "../../../../../components/TabStrip";
import { CustomButton } from "../../../../../components/CustomButton";
import TRFLogsTab from "./TRFLogsTab";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { genericRequestErrorHandler } from "../../../../../api";
import Receivables from "../../../CommonCRSModals/Receivables";
import { InternalLogs } from "../../../CommonCRSModals/InternalLogs";

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailTranferModal: {
    ...modalGenericStyles.modal,
  },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
    padding: "",
    overflowX: "hidden",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: { ...cardStyles.card, maxWidth: "100%" },
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
    maxWidth: "100%",
    overflow: "auto",
    justifyContent: "left",
  },
  firstRow: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    padding: variables.normal_gap,
    gap: variables.normal_gap,
  },
  creatorCardBody: {
    extend: "cardBody",
    padding: [`calc(${variables.normal_gap} * 3.3)`, variables.normal_gap],
  },
  componentRow: {
    extend: "firstRow",
    gridTemplateColumns: "repeat(1, 1fr)",
  },
  [`@media ${variables.media.smallscreen}`]: {
    modalCardBody: {
      minWidth: "60rem",
    },
    firstRow: {
      gridTemplateColumns: "1fr 1fr",
      justifyItems: "center",
    },
  },
});
const DetailTranferModal = ({ market_type, reference, onClose }) => {
  const classes = styles();

  const queryClient = useQueryClient();

  const [activeTab, setActiveTab] = useState("basicInfo");
  const menuTabs = {
    basicInfo: "Basic Info",
    reservationEvents: "Reservation Events",
    receivables: "Receivables",
    documents: "Documents",
    internalLogs: "Internal Logs",
    logs: "User Action Logs",
  };

  const {
    data: transfer,
    guestEditMode,
    guestEditId,
    editCRSTagMode,
    reservationEventsModal,
    openGuestModal,
    closeGuestModal,
    openEditCRSTagModal,
    closeEditCRSTagModal,
    closeReservationEventsModal,
    // loading,
  } = useReservationDetails({
    reference,
    retrieveReservationData: retrieveTransferReservation,
    onCloseDetails: onClose,
  });

  const basicDataCpl = [
    ["Reference", "reference"],
    ["Supplier Reservation Reference", "supplier_reservation_reference"],
    ["Origin Name", "origin_name"],
    ["Supplier", "supplier"],
    ["Tags", null, _.get(transfer, "data.tags", []).join(",")],
    ["Destination", "destination_name"],
    // ["Inbound Vehicle", "inbound_vehicle"],
    // ["Outbound Vehicle", "outbound_vehicle"],
    [
      "Original Service Price",
      null,
      <Price
        currency={_.get(transfer, "data.currency")}
        price={_.get((transfer, "original_service_price"))}
      />,
    ],
    [
      "Refundable",
      null,
      _.get(transfer, "non_refundable") === true ? "Yes" : "No",
    ],
    ["Market Type", "market_type"],
    [
      "Option Booking",
      null,
      _.get(transfer, "option_booking") === true ? "Yes" : "No",
    ],
    [
      "Cancel Until",
      null,
      DateTime.fromISO(
        _.get(transfer, "data.max_cancellation_date")
      ).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY),
    ],
    ["Source Entity", "source_entity"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(transfer, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
    [
      "Status",
      null,
      <ReservationsStatusTag status={_.get(transfer, "data.status")} />,
    ],
  ];
  const creatorDataCpl = [
    ["External Creator", "external_creator"],
    ["Creator", "creator"],
  ];

  const { mutate: onSubmitTags, isLoading: tagsLoading } = useMutation({
    mutationFn: (values) => {
      return patchTransferReservation({ payload: values, reference });
    },
    onSuccess: () => {
      toast.success("Tags updated successfully");
      queryClient.invalidateQueries("transfers");
      onClose();
    },
    onError: (error) => {
      genericRequestErrorHandler(error);
    },
  });

  console.log("transfer", transfer);

  return (
    <div id="DetailTRFModal" className={classes.DetailTranferModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Transfer Details</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {_.isEmpty(transfer) ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicInfo" && (
                <React.Fragment>
                  <div className={classes.firstRow}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        actions={[["Edit", () => openEditCRSTagModal()]]}
                        header="Basic Data"
                        cardInfo={basicDataCpl}
                        objectData={_.get(transfer, "data")}
                      />
                    </div>
                    <div className={classes.creatorCardBody}>
                      <GenericBasicInfo
                        header="Creator Data"
                        cardInfo={creatorDataCpl}
                        objectData={_.get(transfer, "data")}
                      />
                    </div>
                  </div>
                  <div className={classes.componentRow}>
                    <div className={classes.cardBody}>
                      <GuestCard
                        title={"Guest Information"}
                        guests={_.get(transfer, "data.guests", [])}
                        onEditGuest={(id) => {
                          openGuestModal(id);
                        }}
                        onCloseEdit={() => closeGuestModal()}
                      />
                      <EmailsCard
                        title={"Email Informations"}
                        market_type={_.get(transfer, "data.market_type")}
                        reservation_id={_.get(transfer, "data.reference")}
                        service_type="ACC"
                        status={_.get(transfer, "data.status")}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "reservationEvents" && (
                <ReservationEventsModal
                  header="Reservation Events"
                  onClose={() => closeReservationEventsModal()}
                  events={_.get(transfer, "data.reservation_events", [])}
                />
              )}
              {guestEditMode && !reservationEventsModal && !editCRSTagMode && (
                <EditGuestModal
                  onClose={closeGuestModal}
                  guestId={guestEditId}
                  queryKey={`accommodation_reservation_users_documents`}
                  reference={_.get(transfer, "data.reference")}
                  sourceEntity={_.get(transfer, "data.source_entity", "")}
                />
              )}
              {!guestEditMode && !reservationEventsModal && editCRSTagMode && (
                <EditCRSTagModal
                  header={"Transfer"}
                  tags={_.get(transfer, "data.tags")}
                  onClose={closeEditCRSTagModal}
                  onSubmitTags={onSubmitTags}
                />
              )}
              {activeTab === "receivables" && (
                <Receivables data={_.get(transfer, "data.payment_links", [])} />
              )}
              {activeTab === "documents" && (
                <DocumentsCRSCard
                  title="Documents"
                  queryKey={`transfer_reservation_document`}
                  showAddButton={true}
                  tags={[
                    `${_.get(transfer, "data.reference")}_reservation_TRF`,
                  ]}
                  reference={_.get(transfer, "data.reference")}
                  sourceEntity={_.get(transfer, "data.source_entity", "")}
                />
              )}
              {activeTab === "internalLogs" && (
                <InternalLogs
                  prebookData={_.get(transfer, "data.prebook_data", {})}
                  bookData={_.get(transfer, "data.post_booking_data", {})}
                />
              )}
              {activeTab === "logs" && <TRFLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.modalCardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailTranferModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  market_type: PropTypes.oneOf(["B2B", "B2C"]).isRequired,
};
export default DetailTranferModal;
